import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { useWizard } from 'ui-components/components/wizard/context';
import messages from '../../messages';

import style from '../style.module.less';

const ProgressButton = ({ disabled = false }) => {
  const { stepForward, setCanProgress } = useWizard();
  const disableButton = disabled;
  const actionClicked = useCallback(() => {
    stepForward();
    setCanProgress(true);
  }, [setCanProgress, stepForward]);
  return (
    <Button className={style.button} disabled={disableButton} onClick={actionClicked} theme='primary'>
      <FormattedMessage {...messages.continueSetup} />
    </Button>
  );
};

ProgressButton.propTypes = {
  disabled: PropTypes.bool,
};

export default ProgressButton;
